export default "__VITE_ASSET__CYGMQXJR__"